import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getFirestore, doc, getDoc, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import ScrollReveal from "scrollreveal";
import Menu from "../components/Menu.js";
import Loading from "../components/Loading.js";
import {
  FaFacebook,
  FaLinkedin,
  FaWhatsapp,
  FaLink,
} from "react-icons/fa";

const Curriculum = () => {
  const { uid } = useParams(); // UID del receptor (currículum actual)
  const navigate = useNavigate();
  const db = getFirestore();
  const auth = getAuth();
  const [loading, setLoading] = useState(true);
  const [profileData, setProfileData] = useState(null);
  const [currentUser, setCurrentUser] = useState(null); // Usuario autenticado
  const [message, setMessage] = useState("");
  const [emisorName, setEmisorName] = useState("");
  const [receptorName, setReceptorName] = useState("");
  const [contentVisible, setContentVisible] = useState(false);

  // Obtener el usuario autenticado
  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);

        // Buscar el nombre del emisor desde la colección "users"
        const emisorRef = doc(db, "users", user.uid);
        const emisorSnap = await getDoc(emisorRef);
        if (emisorSnap.exists()) {
          setEmisorName(emisorSnap.data().fullName || "Anónimo");
        } else {
          console.error("No se encontró el nombre del usuario emisor.");
        }
      } else {
        navigate("/register");
      }
    });
  }, [auth, db, navigate]);

  // Obtener datos del currículum y el nombre del receptor
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        // Obtener datos del currículum
        const docRef = doc(db, "postulantes", uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setProfileData(docSnap.data());

        } else {
          console.error("No se encontró el currículum para este usuario.");
        }

        // Buscar el nombre del receptor desde la colección "users"
        const receptorRef = doc(db, "users", uid);
        const receptorSnap = await getDoc(receptorRef);
        if (receptorSnap.exists()) {
          setReceptorName(receptorSnap.data().fullName || "Desconocido");
        } else {
          console.error("No se encontró el nombre del usuario receptor.");
        }
      } catch (error) {
        console.error("Error al obtener los datos del currículum o receptor:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfileData();
  }, [uid, db]);

  useEffect(() => {
    setTimeout(() => {
      setContentVisible(true);
    const sr = ScrollReveal({
      origin: "top", // Dirección de aparición
      distance: "80px", // Distancia del efecto
      duration: 2000, // Duración de la animación
      reset: true, // Hace que el efecto se repita al hacer scroll
    });

    // Aplicar efecto a cada elemento con su respectiva clase
    sr.reveal(".home-title", {});
    sr.reveal(".button", { delay: 200 });
    sr.reveal(".home-img", { delay: 400 });
    sr.reveal(".home-social", { delay: 400 });

    sr.reveal(".about-img", {});
    sr.reveal(".about-subtitle", { delay: 200 });
    sr.reveal(".about-text", { delay: 400 });

    sr.reveal(".skills-subtitle", { delay: 100 });
    sr.reveal(".skills-text", { delay: 150 });
    sr.reveal(".skills-data", { interval: 200 });
    sr.reveal(".skills-img", { delay: 400 });

    sr.reveal(".work-img", { interval: 200 });

    sr.reveal(".contact-input", { interval: 200 });
  }, 2100);
  }, []);

  // Manejar el envío del mensaje
  const handleSendMessage = async () => {
    if (!message) {
      alert("Por favor, completa el mensaje.");
      return;
    }

    try {
      const messageData = {
        mensaje: message,
        emisor: {
          nombre: emisorName,
          uid: currentUser.uid,
        },
        receptor: {
          nombre: receptorName,
          uid: uid,
        },
        fechaHora: serverTimestamp(), // Timestamp de la fecha y hora actual
      };

      await addDoc(collection(db, "mensajes"), messageData);
      alert("Mensaje enviado con éxito.");
      setMessage(""); // Limpiar el campo de mensaje
    } catch (error) {
      console.error("Error al enviar el mensaje:", error);
      alert("Hubo un error al enviar el mensaje.");
    }
  };

  if (loading) {
    return <div><Loading /></div>;
  }

  if (!profileData) {
    return <p>No se encontró información del currículum para este usuario.</p>;
  }

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`,
    x: `https://twitter.com/intent/tweet?url=${window.location.href}`,
    whatsapp: `https://wa.me/?text=Este curriculum te puede interesar: ${window.location.href}`,
  };



  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    alert("Enlace copiado al portapapeles");
  };

  return (
    <div className="vp-container">
      <Menu />
      <div className="vp-main-content">
        <div className="tab-content tab-content-cv">
          <main className="l-main">
            <section className="home bd-grid" id="home">
            <h2>Currículum Vitae</h2>
              <div className="home-data">
                <h1 className="home-title">
                  Hola, <br />soy <span className="home-title-color"><strong>{receptorName || "Desconocido"}</strong></span>
                  <br />
                </h1>
              </div>
                {/* COMPARTIR EL CURRICULUM */}
              <div className="home-social">
                <div className="compartir-tarjeta">
                  <h3 className="compartir-titulo">Compartir CV</h3>
                  <div className="iconos-refs-c">
                    <ul className="wrapper-icons sci">
                        <li className="icon-c comentarios">
                            <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer">
                            <span><FaFacebook /></span>
                            </a>
                        </li>
                        <li className="icon-c comentarios">
                            <a href={shareLinks.linkedin} target="_blank" rel="noopener noreferrer">
                            <span><FaLinkedin /></span>
                            </a>
                        </li>
                        <li className="icon-c comentarios">
                            <a href={shareLinks.x} target="_blank" rel="noopener noreferrer">
                            <span><i className="fa-brands fa-x-twitter"></i></span>
                            </a>
                        </li>
                        <li className="icon-c comentarios">
                            <a href={shareLinks.whatsapp} target="_blank" rel="noopener noreferrer">
                            <span><FaWhatsapp /></span>
                            </a>
                        </li>
                        <li className="icon-c comentarios">
                            <a href="#" onClick={handleCopyLink}>
                            <span><FaLink /></span> {/* Ícono para copiar enlace */}
                            </a>
                        </li>
                        </ul>
                  </div>
                </div>
              </div>

              <div className="home-img">
                <img src={profileData.profileImage} alt="image" />
              </div>
            </section>

            {/* Sección About */}
            <section className="about section" id="about">
              <h2 className="section-title">Sobre mi</h2>
              <div className="about-container bd-grid">
                <div className="about-img">
                  {profileData.videos && profileData.videos.length > 0 ? (
                    profileData.videos.map((video, index) => (
                      <div key={index}>
                        <video
                          src={video}
                          controls
                          style={{ maxWidth: "300px", width: "100%" }}
                        />
                      </div>
                    ))
                  ) : (
                    <p>No se cargaron videos.</p>
                  )}
                </div>
                <div>
                  <h2 className="about-subtitle">Soy {receptorName || "Desconocido"}</h2>
                  <p className="about-text">
                  {profileData.about || "No especificado"}
                  </p>
                </div>
              </div>
            </section>

                {/* Sección Skills */}
            <section className="skills section" id="skills">
              <h2 className="section-title">Habilidades</h2>
              <div className="skills-container bd-grid">
                <div className="conteinerTextoSill">
                  {/* Renderizar las habilidades dinámicamente */}
                    {profileData.skills && profileData.skills.length > 0 ? (
                      profileData.skills.map((skill, index) => (
                        <div className="skills-data" key={index}>
                          <div className="skills-names">
                            <span className="skills-name">{skill}</span> {/* Ahora muestra cada habilidad individual */}
                          </div>
                          <div>
                            <span className="skills-percentage"></span>
                          </div>
                          <div className="skills-bar"></div>
                        </div>
                      ))
                    ) : (
                      <p>No hay habilidades registradas.</p>
                    )}
                </div>
                <div className="conteinerImgSkill">
                  <img src="https://i.postimg.cc/52LWbPyt/work3.jpg" alt="image" className="skills-img" />
                </div>
              </div>
            </section>
              {/* Sección Work */}
            <section className="work section" id="work">
              <h2 className="section-title">Trabajos</h2>
              <div className="work-container bd-grid">
                  <div className="work-img">
                    <h3>Experiencia</h3>
                    <p>{profileData.experience || "No especificado"}</p>
                  </div>   
                  <div className="work-img">
                    <h3>Tipo de experiencia buscada</h3>
                    <p>{profileData.jobExpectations || "No especificado"}</p>
                  </div>   
                  <div className="work-img">
                    <h3>Remuneración requerida</h3>
                    <p>{profileData.salary || "No especificado"}</p>
                  </div>   
              </div>
            </section>      
          </main>        

          {/* Mostrar formulario de mensaje solo si el usuario está autenticado */}
          {currentUser && (
            <div>
              <h4>Enviar mensaje</h4>
              <div>
                <label>Mensaje:</label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Escribe tu mensaje"
                  rows="5"
                />
              </div>
              <button className="btn btn-success" onClick={handleSendMessage}>
                Enviar mensaje
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default Curriculum;
